class PostSelection {
  constructor(product, defaultVariant) {
    this.page = 1;
    this.product = product;
    this.defaultVariant = defaultVariant;
    this.selectedVariant = this.defaultVariant;
    this.atcBtns = document.querySelectorAll(".post-selection__atc-btn");
    this.shoppingBtn = document.querySelector(".post-selection__shopping-btn");
    this.backBtn = document.querySelector(".post-selection__back-btn");
    this.nextBtn = document.querySelector(".post-selection__next-btn");
    this.checkoutBtn = document.querySelector(".post-selection__checkout-btn");
    this.infoContent = document.querySelector(".post-selection__info-content");
    this.itemsContainer = document.querySelector(
      ".post-selection__items-container"
    );
    this.variantOptions = document.querySelectorAll(
      ".post-selection__variants-container input[type='radio']"
    );
    this.variantOptionsCross = document.querySelectorAll(
      ".post-selection__variants-cross input[type='radio']"
    );

    this.upsellOptions = document.querySelectorAll(
      ".post-selection__item input[type='checkbox']"
    );

    this.overlayOptionInputs = document.querySelectorAll(
      ".post-selection__overlay-option-input"
    );

    this.overview = document.querySelector(".post-selection__overview");
    this.overviewList = document.querySelector(
      ".post-selection__overview-list"
    );
    this.overviewBtn = document.querySelector(".post-selection__overview-btn");
    this.insuranceInfoBtn = document.querySelector(
      ".post-selection__insurance-info"
    );
    this.infoBackBtn = document.querySelector(".post-selection__back-info");
    this.imageContainer = document.querySelector(".post-selection__image-container");
    this.mainProductImage = this.imageContainer.querySelector("img");
    this.activeOverlays = new Set(); // Track active overlays to prevent duplicates
    this.overlayImageCache = {}; // Cache for overlay images from metaobjects
    
    // Map to store static z-index values for each accessory based on their position in UI
    this.itemZIndexMap = new Map();
    this._initializeZIndexMap();
    
    this.overlayState = new Map(); // new array for storing state
    
    this._init();
    this.drawerShow = true;
    this.drawerOpened = false;
    this._preloadAllOverlayImages(); // Preload all overlay images when the constructor runs
  }

  _setPage(page) {
    document.querySelectorAll("[data-page]").forEach((item) => {
      item.style.display = "block";
    });
    
    document.querySelector(".post-selection__summary").style.display = "flex";
    document.querySelector(".post-selection__items-container").style.display = "flex";
    this.infoContent.style.height = "100%";
    
    this._setupSinglePageNavigation();
  }

  _setupSinglePageNavigation() {
    if (this.backBtn) this.backBtn.style.display = "none";
    if (this.nextBtn) this.nextBtn.style.display = "none";
    
    if (this.shoppingBtn) this.shoppingBtn.style.display = "none";
    if (this.checkoutBtn) this.checkoutBtn.style.display = "flex";
    
    if (this.overview) this.overview.style.display = "block";
    
    if (this.infoBackBtn) this.infoBackBtn.style.display = "none";
  }

  _handleNavButtons() {
    this._setupSinglePageNavigation();
  }

  _init() {
    this._microModal();
    this._splide();
    this._setPage(1);
    this._events();
    // Always show insurance shields
    this._updateInsuranceShields(true);
    this._preselectVariant();
    this._initializeZIndexMap();
    // Initialize overlay images for any pre-selected accessories
    this._initializeAccessoryOverlays();
    // Preload all overlay images to improve performance
    this._preloadAllOverlayImages();
    // console.log('Post Selection Initialized');
  }

  _preselectVariant() {
    // preselect Gemonteerd variant for OUXi
    const vendor = document.querySelector(".post-selection").dataset.vendor;
    if (vendor === "OUXI") {
      this.variantOptions[0].click();
    }
  }

  _splide() {
    new Splide(".splide", {
      type: "loop",
      perPage: 1,
      pagination: false,
      interval: 3000,
      speed: 800,
      autoplay: true,
      cover: false,
    }).mount();
  }

  _microModal() {
    this.microModalOptions = {
      openTrigger: "data-micromodal-open", // [3]
      closeTrigger: "data-micromodal-close", // [4]
      openClass: "is-open", // [5]
      disableScroll: true, // [6]
      disableFocus: false, // [7]
      awaitOpenAnimation: true, // [8]
      awaitCloseAnimation: true, // [9]
      debugMode: false, // [10]
      onShow: () => {
        this._preventBodyScroll();
      },
      onClose: () => {
        this._allowBodyScroll();
      }
    };
    MicroModal.init(this.microModalOptions);

    const modal = document.querySelector(".modal");
    const section = modal.closest(".section");

    // Move the modal to the section bottom
    if (modal && section) {
      section.appendChild(modal);
    }
  }

  _preventBodyScroll() {
    document.body.classList.add('pp-no-scroll');
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    
    // Add touch event listener to the modal overlay to prevent scrolling
    const modalOverlay = document.querySelector('.modal__overlay');
    if (modalOverlay) {
      // Use arrow function to maintain 'this' context
      this._boundHandleTouchMove = (e) => this._handleModalTouchMove(e);
      modalOverlay.addEventListener('touchmove', this._boundHandleTouchMove, { passive: false });
    }
  }
  
  _allowBodyScroll() {
    document.body.classList.remove('pp-no-scroll');
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.width = '';
    
    // Remove touch event listener from modal overlay
    const modalOverlay = document.querySelector('.modal__overlay');
    if (modalOverlay && this._boundHandleTouchMove) {
      modalOverlay.removeEventListener('touchmove', this._boundHandleTouchMove);
      this._boundHandleTouchMove = null;
    }
  }
  
  _handleModalTouchMove(e) {
    // Allow scrolling only inside scrollable elements
    if (!e.target.closest('.post-selection__items-container') && 
        !e.target.closest('.post-selection__info-content') &&
        !e.target.closest('.post-selection__insurance-policy-content')) {
      e.preventDefault();
    }
  }

  _events() {
    this.atcBtns.forEach((btn) =>
      btn.addEventListener("click", () => {
        this._handleATCBtn();
      })
    );

    if (this.backBtn) {
      this.backBtn.addEventListener("click", () => {
        // No page changing needed
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener("click", () => {
        // No page changing needed
      });
    }

    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener("click", () => {
        this._handleCheckoutBtn();
      });
    }

    this.upsellOptions.forEach((input) => {
      input.addEventListener("change", (e) => {
        if (input.dataset.cross === "false") {
          this._updatePrices();
          this._updateOverview();
          this._checkInsuranceItems();
          this._checkCrossVariant();
          this._checkServices(e);
          this._updateAccessoryOverlays(input);
          
          // Handle multi-overlay options - enable/disable option checkboxes
          if (input.dataset.hasMultipleOverlays === "true") {
            this._toggleOverlayOptions(input);
          }
        } else {
          this._checkUpsellBasedOnCross(input);
        }
      });
    });

    // Add event listeners for overlay option checkboxes
    this.overlayOptionInputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        // Get the parent checkbox that controls this accessory
        const parentCheckboxId = input.dataset.parentCheckbox;
        const parentCheckbox = document.getElementById(parentCheckboxId);
        
        if (parentCheckbox && parentCheckbox.checked) {
          this._handleOverlayOptionChange(input);
        }
      });
    });

    // Event delegation for the close button
    this.overviewList.addEventListener("click", (e) => {
      const closeBtn = e.target.closest(".post-selection__overview-item-close");
      if (closeBtn) {
        const variantId = closeBtn.closest("li").dataset.variant;
        this._removeListItem(variantId);
      }
    });

    this.overviewBtn.addEventListener("click", (e) => {
      this.overviewBtn.classList.toggle("active");
    });

    if (this.insuranceInfoBtn) {
      this.insuranceInfoBtn.addEventListener("click", (e) => {
        const insurancePolicy = document.querySelector(".post-selection__insurance-policy");
        if (insurancePolicy) {
          insurancePolicy.style.display = insurancePolicy.style.display === "none" ? "block" : "none";
        }
      });
    }

    this.variantOptions.forEach((input) => {
      input.addEventListener("change", (e) => {
        let previousVariant = this.selectedVariant;

        this.selectedVariant = this._getSelectedVariant().id;
        this._updateURL();
        this._updatePrices();
        this._updateSelectedVariantText(e);
        this._updateOverview();
        this._updateInsuranceNote(e);
        this._checkInsuranceItems();
        this._updateDelivery();
        this._updateCrossVariants(e);
        this._checkCrossVariant();
      });
    });

    this.variantOptionsCross.forEach((input) => {
      input.addEventListener("change", (e) => {
        const selectedValue = e.target.value.replace("-cross", "");
        const optionToClick = [...this.variantOptions]
          .filter((input) => input.value === selectedValue)
          .pop();

        optionToClick.click();
      });
    });
  }

  _checkUpsellBasedOnCross(input) {
    const targetValue = input.id.replace("variant-", "").replace("-cross", "");
    const targetUpsell = document.querySelector(
      `.post-selection__item input[value='${targetValue}']`
    );
    if (targetUpsell) {
      input.checked = false;
      targetUpsell.click();
    }
  }

  _checkServices(e) {
    const item = e.target.closest(".post-selection__item");
    const isService = item.dataset.service === "true";
    if (isService) {
      const selectedService = e.target.value;
      const serviceItems = document.querySelectorAll(
        '.post-selection__item[data-service="true"] input[type="checkbox"]'
      );

      serviceItems.forEach((serviceItem) => {
        if (serviceItem !== e.target) {
          serviceItem.checked = false;
        }
      });

      this._updateOverview();
      this._updatePrices();
    }
  }

  _checkCrossVariant() {
    const selectedUpsells = this._getUpsellItems();
    const mainItem = this._getSelectedVariant();

    // Safety check if mainItem or its options aren't available
    if (!mainItem || !mainItem.options) {
      // console.warn('Selected variant or its options not available in _checkCrossVariant');
      return;
    }

    const isMounted = mainItem.options.includes("Gemonteerd");
    const isArtLock = selectedUpsells.some((item) =>
      item && item.title && item.title.toLowerCase().includes("art")
    );
    const isLoqater = selectedUpsells.some((item) =>
      item && item.title && item.title.toLowerCase().includes("loqater")
    );

    const crossSaleSection = document.querySelector(
      ".post-selection__cross-sale"
    );
    
    if (!crossSaleSection) return;
    
    crossSaleSection.style.display =
      isMounted && isArtLock && isLoqater ? "none" : "flex";

    const displayStyle = (condition) => (condition ? "none" : "block");
    
    const optionElement = crossSaleSection.querySelector(".post-selection__option");
    if (optionElement) {
      optionElement.style.display = displayStyle(isMounted);
    }
    
    const slotenInput = crossSaleSection.querySelector(".post-selection__item input[name='categorie_sloten']");
    if (slotenInput) {
      const slotenItem = slotenInput.closest(".post-selection__item");
      if (slotenItem) {
        slotenItem.style.display = displayStyle(isArtLock);
      }
    }
    
    const gpsInput = crossSaleSection.querySelector(".post-selection__item input[name='categorie_gps']");
    if (gpsInput) {
      const gpsItem = gpsInput.closest(".post-selection__item");
      if (gpsItem) {
        gpsItem.style.display = displayStyle(isLoqater);
      }
    }
  }

  _updateCrossVariants(e) {
    const selectedCrossOption = [...this.variantOptionsCross].find(
      (input) => input.value === `${e.target.value}-cross`
    );
    selectedCrossOption.click();
  }

  _updateDelivery() {
    const variantInventory = document.querySelector(
      ".post-selection__inventory variant-inventory"
    );

    const variants = variantInventory.querySelectorAll("[data-variant-id]");

    variants.forEach((variant) => {
      variant.setAttribute("hidden", "");
    });
    variants.forEach((variant) => {
      if (+variant.dataset.variantId === this.selectedVariant) {
        variant.removeAttribute("hidden");
      }
    });
  }

  _handleATCBtn() {
    MicroModal.show("modal-1", this.microModalOptions);
  }

  _adjustItemsConatinerHeight() {
    this.itemsContainer.style.maxHeight = `${
      this.itemsContainer.scrollHeight + 20
    }px`;
  }

  _handleCheckoutBtn() {
    this.checkoutBtn.querySelector(
      ".post-selection__checkout-btn-inner"
    ).style.display = "none";
    this.checkoutBtn.querySelector(
      ".post-selection__btn-loader"
    ).style.display = "flex";

    const mainItem = [
      {
        id: Number(this.selectedVariant),
        quantity: 1,
      },
    ];

    // console.log('Adding main item to cart:', mainItem);

    this._addVariantsToCart(mainItem, () => {
      this._handleUpsellItems();
    });
  }

  _handleUpsellItems() {
    const upsellItems = this._getUpsellItems().map((item) => {
      return {
        id: Number(item.id),
        quantity: Number(item.quantity || 1), // Ensure quantity is a proper number
      };
    });

    // console.log('Upsell items to add:', upsellItems);

    if (upsellItems.length > 0) {
      const upsellItemsWithoutIncluded = upsellItems
        .filter((item) => item.id !== 0)
        .reduce((acc, item) => {
          // Check if the id already exists in the accumulator
          const existingItem = acc.find((i) => i.id === item.id);
          
          // If the id already exists, add to its quantity
          if (existingItem) {
            existingItem.quantity += Number(item.quantity || 1);
          } else {
            // Otherwise add the item to the accumulator
            acc.push({
              id: Number(item.id),
              quantity: Number(item.quantity || 1)
            });
          }
          return acc;
        }, []);

      // console.log('Consolidated upsell items:', upsellItemsWithoutIncluded);

      this._addVariantsToCart(upsellItemsWithoutIncluded, () => {
        this.drawerShow ? false : (window.location.href = "/cart");
      });
    } else {
      this.drawerShow ? false : (window.location.href = "/cart");
    }
  }

  _getSelectedVariant() {
    const selectedOptions = [];
    const selected = document.querySelectorAll(
      ".post-selection__variants-container input[type='radio']:checked"
    );

    selected.forEach((input) => {
      const optionValue = input.value;
      selectedOptions.push(optionValue);
    });

    const matchedVariant = this.product.variants.find((variant) =>
      selectedOptions.every((optionValue) =>
        variant.options.includes(optionValue)
      )
    );

    return matchedVariant;
  }

  _getUpsellItems() {
    const checked = Array.from(
      document.querySelectorAll(".post-selection__item input[type='checkbox']:checked")
    );

    // First get standard items
    const standardItems = checked.map((input) => {
      // Skip if this is a special hidden checkbox for overlay options
      if (input.classList.contains('post-selection__hidden-checkbox')) {
        return null;
      }
      
      return {
        id: Number(input.value),
        productId: Number(input.dataset.productId || 0),
        title: input.dataset.title,
        price: Number(input.dataset.price || 0),
        img: input.dataset.img,
        overlayImg: input.dataset.overlayImg,
        metafield: input.name,
        quantity: 1,
        options: []
      };
    }).filter(item => item !== null);
    
    // Now get overlay option items
    const hiddenCheckboxes = Array.from(
      document.querySelectorAll(".post-selection__item input.post-selection__hidden-checkbox")
    );
    
    // For each hidden checkbox, look for its associated option checkboxes
    const overlayOptionItems = hiddenCheckboxes.map(hiddenCheckbox => {
      const variantId = hiddenCheckbox.value;
      const productId = Number(hiddenCheckbox.dataset.productId || 0);
      
      // Find all selected options for this variant
      const selectedOptions = document.querySelectorAll(
        `.post-selection__overlay-option-input[data-variant-id="${variantId}"]:checked`
      );
      
      if (selectedOptions.length === 0) {
        return null;
      }
      
      // Instead of creating multiple items, create ONE item with the correct quantity
      // and use the options array to track details for display purposes
      const optionDetails = Array.from(selectedOptions).map(option => {
        return {
          name: option.value,
          price: Number(option.dataset.optionPrice || 0)
        };
      });
      
      return {
        id: Number(variantId),
        productId: productId,
        title: `${hiddenCheckbox.dataset.title} (${selectedOptions.length} opties)`,
        price: Number(hiddenCheckbox.dataset.price || 0),
        img: hiddenCheckbox.dataset.img,
        overlayImg: selectedOptions[0].dataset.overlayUrl || hiddenCheckbox.dataset.overlayImg,
        metafield: hiddenCheckbox.name,
        quantity: selectedOptions.length, // Set quantity to match number of selected options
        options: optionDetails
      };
    })
    .filter(item => item !== null);
    
    // Combine standard items and overlay option items
    return [...standardItems, ...overlayOptionItems];
  }

  _updateHeaderCounter() {
    fetch(window.Shopify.routes.root + "?sections=header")
      .then((res) => res.json())
      .then((htmlString) => {
        const parser = new DOMParser();
        const header = parser.parseFromString(htmlString.header, "text/html");
        const cartCount = header.querySelector(".header__cart-count");
        document.querySelector(".header__cart-count").replaceWith(cartCount);
      });
  }

  _updateSelectedVariantText(e) {
    const selectedValue = e.target.value;
    const selectedOption = e.target
      .closest(".post-selection__option")
      .querySelector(".post-selection__selected-option");
    if (selectedOption) {
      selectedOption.textContent = selectedValue;
    }
  }

  _updatePrices() {
    //Matched variant
    const matchedVariant = this.product.variants.find(
      (variant) => variant.id === this.selectedVariant
    );
    // Update post-selection module prices
    const comparePrice = document.querySelector(
      ".post-selection__compare-price"
    );
    const totalPrice = document.querySelector(".post-selection__total-price");
    const discountBadge = document.querySelector(".post-selection__discount-badge span");
    
    const upsellItems = this._getUpsellItems();
    const totalUpsellPrice = upsellItems
      .filter((item) => item.id !== 0)
      .reduce((acc, item) => {
        // Check if the id already exists in the accumulator
        const idExists = acc.some((i) => i.id === item.id);
        // If the id does not exist in the accumulator, add the item
        if (!idExists) {
          acc.push(item);
        }
        return acc;
      }, [])
      .reduce((acc, item) => {
        // Multiply the price by the quantity (defaults to 1 if not specified)
        return acc + (item.price * (item.quantity || 1));
      }, 0);
    
    if (comparePrice && matchedVariant.compare_at_price) {
      const originalPrice = matchedVariant.compare_at_price + totalUpsellPrice;
      const discountedPrice = matchedVariant.price + totalUpsellPrice;
      
      comparePrice.textContent = this._formatPrice(originalPrice);
      
      // Update discount savings if discount badge exists
      if (discountBadge) {
        const discountAmount = originalPrice - discountedPrice;
        // Format as integer with comma for thousands and append ",-"
        const formattedAmount = Math.floor(discountAmount / 100);
        discountBadge.textContent = `Bespaar ${formattedAmount},-`;
      }
    }
    
    totalPrice.textContent = this._formatPrice(
      matchedVariant.price + totalUpsellPrice
    );
  }

  _updateOverview() {
    this.overviewList.innerHTML = "";

    const selectedVariant = this.product.variants.find(
        (variant) => variant.id === this.selectedVariant
    );

    // Add main variant
    this._addItemToList(
        this.product.title,
        this._formatPrice(selectedVariant.price),
        this.product.featured_image,
        this.selectedVariant
    );

    // Add upsells
    const upsellItems = this._getUpsellItems()
        .filter((item) => item.id !== 0)
        .reduce((acc, item) => {
            // Check if the id already exists in the accumulator
            const existingItem = acc.find((i) => i.id === item.id);
            // If the id already exists, update it with combined information
            if (existingItem) {
                existingItem.quantity = (existingItem.quantity || 1) + (item.quantity || 1);
                existingItem.price += item.price;
                if (item.options.length > 0) {
                    existingItem.options = [...existingItem.options, ...item.options];
                }
            } else {
                // Otherwise, add the item to the accumulator
                acc.push(item);
            }
            return acc;
        }, []);

    // Update overview list with selected items
    upsellItems.forEach((upsell) => {
        // Format title with quantity if needed
        let displayTitle = upsell.title;
        if (upsell.quantity > 1) {
            if (!displayTitle.includes('opties)')) {
                displayTitle = `${upsell.title} (${upsell.quantity}x)`;
            }
        }
        
        // Calculate total price
        const totalPrice = upsell.price * (upsell.quantity || 1);
        
        // Add to overview list using regular image
        this._addItemToList(
            displayTitle,
            this._formatPrice(totalPrice),
            upsell.img,
            upsell.id,
            upsell.quantity
        );
        
        // НЕ добавляем оверлеи здесь - они уже должны быть добавлены через _updateAccessoryOverlays
    });
  }

  _updateInsuranceNote(e) {
    const insuranceNote = e.target
      .closest(".post-selection__option")
      .querySelector(".post-selection__insurance-note");

    if (!insuranceNote) return;

    const insuranceDeny = insuranceNote.querySelector(
      ".post-selection__insurance-deny"
    );
    const insuranceApprove = insuranceNote.querySelector(
      ".post-selection__insurance-approve"
    );
    
    // Always show approval message
    if (insuranceDeny) insuranceDeny.style.display = "none";
    if (insuranceApprove) insuranceApprove.style.display = "flex";
    this._updateInsuranceShields(true);
  }

  _updateInsuranceShields(show) {
    const productShields = document.querySelectorAll(
      ".post-selection__item-product-shield"
    );
    productShields.forEach((shield) => {
      shield.style.display = show ? "inline-flex" : "none";
    });
  }

  _checkInsuranceItems() {
    const insuranceCat = document.querySelector(
      '.post-selection__items-category[data-insurance="true"]'
    );
    const insuranceNote = document.querySelector(
      ".post-selection__insurance-note--final"
    );

    if (!insuranceCat || !insuranceNote) return;

    // Always enable insurance regardless of conditions
    insuranceCat.classList.remove("disabled");
    if (insuranceCat.querySelector("input")) {
      insuranceCat.querySelector("input").disabled = false;
    }
    
    if (insuranceNote) {
      if (insuranceNote.querySelector(".post-selection__insurance-deny")) {
        insuranceNote.querySelector(".post-selection__insurance-deny").style.display = "none";
      }
      if (insuranceNote.querySelector(".post-selection__insurance-approve")) {
        insuranceNote.querySelector(".post-selection__insurance-approve").style.display = "flex";
      }
    }
  }

  _createListItem(title, price, imgSrc, variantId, quantity = 1) {
    // Get the template content
    const template = document.getElementById("listItemTemplate");
    const clone = template.content.cloneNode(true);

    // Set the title, price, and image source
    clone.querySelector(".post-selection__item-product-title").textContent = title;
    clone.querySelector(".post-selection__item-product-price").textContent = price;
    
    // Add quantity indicator if more than 1
    if (quantity > 1) {
      const priceElement = clone.querySelector(".post-selection__item-product-price");
      const quantitySpan = document.createElement('span');
      quantitySpan.className = 'post-selection__item-quantity';
      quantitySpan.textContent = `(${quantity}x)`;
      priceElement.parentNode.insertBefore(quantitySpan, priceElement);
    }
    
    clone.querySelector(".post-selection__overview-img").src = imgSrc;
    clone.querySelector(".post-selection__overview-item").setAttribute("data-variant", variantId);
    clone.querySelector(".post-selection__overview-item").setAttribute("data-quantity", quantity);

    return clone;
  }

  _addItemToList(title, price, imgSrc, variantId, quantity = 1) {
    this.overviewList.style.display = "flex";
    const listItem = this._createListItem(title, price, imgSrc, variantId, quantity);
    this.overviewList.appendChild(listItem);
  }

  _removeListItem(variantId) {
    const listItem = this.overviewList.querySelector(
      `.post-selection__overview-item[data-variant='${variantId}']`
    );
    
    if (!listItem) return;
    
    listItem.remove();
    
    const checkBoxes = document.querySelectorAll(`input#variant-${variantId}`);
    checkBoxes.forEach((checkBox) => {
      if (checkBox) {
        checkBox.checked = false;
      }
    });
    
    const checkBoxesCross = document.querySelectorAll(
      `input#variant-${variantId}-cross`
    );
    checkBoxesCross.forEach((checkBox) => {
      if (checkBox) {
        checkBox.checked = false;
      }
    });

    if (this.overviewList.children.length === 0) {
      this.overviewList.style.display = "none";
    }
    
    this._updatePrices();
    this._checkInsuranceItems();
    this._checkCrossVariant();
    this._updateOverview(); // This will now manage all overlays
  }

  _formatPrice(priceInCents) {
    let price = priceInCents / 100;
    price = price.toLocaleString("nl-NL", { maximumFractionDigits: 2 });
    return `${price},-`;
  }

  _updateURL() {
    const url = new URLParse(window.location.href, true);
    const newVariantValue = this.selectedVariant;
    url.query.variant = newVariantValue;
    window.history.replaceState(null, null, url.toString());
  }

  _getCart() {
    return fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then((response) => response.json());
  }

  _addVariantsToCart(items, cb = null) {
    if (!items || !Array.isArray(items) || items.length === 0) {
      // console.warn('No valid items to add to cart');
      if (cb) cb();
      return;
    }
    
    // Filter out any invalid items (missing id or invalid id)
    const validItems = items.filter(item => {
      if (!item || !item.id || isNaN(Number(item.id)) || Number(item.id) <= 0) {
        // console.error('Invalid cart item:', item);
        return false;
      }
      return true;
    });
    
    if (validItems.length === 0) {
      // console.warn('No valid items after filtering');
      if (cb) cb();
      return;
    }
    
    const drawerId = document
      .querySelector("cart-drawer")
      .parentElement.id.replace("shopify-section-", "");
    
    let str = "";
    this.drawerOpened = validItems.length > 0;
    if (validItems.length > 0) {
      str = `/variants/${validItems[0].id}`;
    }
    
    // Make sure all items have proper formatting for Shopify Cart API
    const formattedItems = validItems.map(item => {
      const payload = {
        id: parseInt(item.id),
        quantity: parseInt(item.quantity || 1)
      };

      // FAT-327 — stamp the delivery message onto the line so it reaches the order (and Klaviyo)
      // as `_delivery_time`. Every add from the configurator funnels through here — the bike and
      // the upsells alike — so this is the only place that needs it. Like every other property
      // the value is deterministic per render, so lines still merge; a variant with no delivery
      // metafield gets no property at all.
      const deliveryTime = this._deliveryTimeFor(payload.id);
      if (deliveryTime) {
        payload.properties = { _delivery_time: deliveryTime };
      }

      return payload;
    });
    
    // console.log('Adding to cart:', formattedItems);
    
    let formData = {
      items: formattedItems,
      sections: `variant-added,${drawerId}`,
      sections_url: str,
    };
    
    if (this.drawerShow) {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: ["variant-added"] },
        })
      );
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          // console.error('Cart add error:', response.status);
          return response.json().then(err => {
            // console.error('Cart error details:', err);
            throw err;
          });
        }
        return response.json();
      })
      .then((responseJson) => {
        // console.log('Cart add success:', responseJson);
        this.drawerShow && this.drawerOpened
          ? this._openDrawer(responseJson)
          : false;
      })
      .catch((error) => {
        // console.error("Error adding to cart:", error);
      })
      .finally(() => {
        if (cb) {
          cb();
        }
        this.drawerShow ? this._closeModal() : false;
      });
  }

  // FAT-327 — the delivery message for a variant about to be added. Upsells carry theirs on the
  // checkbox (data-delivery-time, from post-selection-item.liquid); the bike is looked up in the
  // variant map that et-delivery-line-property renders — on this theme from post-selection.liquid,
  // since the product template has no buy_buttons block. Empty string means "add no property".
  _deliveryTimeFor(variantId) {
    const checkbox = document.querySelector(
      `.post-selection__item input[type="checkbox"][value="${variantId}"][data-delivery-time]`
    );

    if (checkbox && checkbox.dataset.deliveryTime) {
      return checkbox.dataset.deliveryTime;
    }

    return window.ETDeliveryTimes ? window.ETDeliveryTimes.get(variantId) : "";
  }

  async _openDrawer(responseJson) {
    const cartContent = await (await fetch(`/cart.js`)).json();
    cartContent["sections"] = responseJson["sections"];
    document.documentElement.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items")
            ? responseJson["items"]
            : [responseJson],
          cart: cartContent,
        },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent,
        },
      })
    );
  }
  _closeModal() {
    document
      .querySelector(".micromodal-slide [data-micromodal-close] ")
      .click();
    this.checkoutBtn.querySelector(
      ".post-selection__checkout-btn-inner"
    ).style.display = "flex";
    this.checkoutBtn.querySelector(
      ".post-selection__btn-loader"
    ).style.display = "none";

    this._handleBackBtn();
  }

  _removeVariantsFromCart(variantToRemove, cb = null) {
    let updates = {
      [variantToRemove]: 0,
    };
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        // console.error("Error:", error);
      })
      .finally(() => {
        if (cb) {
          cb();
        }
      });
  }

  _clearAllOverlays() {
    // console.log('Clearing all overlays');
    const allOverlays = this.imageContainer.querySelectorAll('.post-selection__overlay-image');
    allOverlays.forEach(overlay => overlay.remove());
    
    // Reset the tracking Set
    this.activeOverlays = new Set();
  }

  _updateAccessoryOverlays(checkbox) {
    const variantId = checkbox.value;
    const productId = checkbox.dataset.productId;
    const title = checkbox.dataset.title;
    
    // console.log(`Updating overlay for ${title} (checked: ${checkbox.checked})`);
    
    if (!checkbox.checked) {
        this._removeAllVariantOverlays(variantId);
        return;
    }
    
    const hasOptions = document.querySelectorAll(
        `.post-selection__overlay-option-input[data-variant-id="${variantId}"]`
    ).length > 0;
    
    if (hasOptions) {
        this._handleMultipleOverlayOptionsChange(variantId);
    } else {
        this._checkAndCreateOverlayOptions(productId, variantId, checkbox);
    }
  }

  _checkAndCreateOverlayOptions(productId, variantId, checkbox) {
    const bikeProductId = this.product.id;
    
    const overlayEntries = document.querySelectorAll(
        `.post-selection__overlay-mapping[data-overlay-product-id="${productId}"][data-placement-product-id="${bikeProductId}"][data-overlay-option]`
    );
    
    if (overlayEntries.length === 0) {
        this._fetchAndAddOverlayImage(productId, variantId, checkbox.dataset.title, event);
        return;
    }
    
    let optionsContainer = this._getOrCreateOptionsContainer(checkbox, variantId, productId);
    if (!optionsContainer) {
        this._fetchAndAddOverlayImage(productId, variantId, checkbox.dataset.title, event);
        return;
    }
    
    // Clear existing options
    optionsContainer.innerHTML = '';
    
    // Create a checkbox for each option
    overlayEntries.forEach((entry, index) => {
        const optionValue = entry.dataset.overlayOption;
        const optionId = `overlay-option-${variantId}-${index}`;
        const parentCheckboxId = checkbox.id;
        const imageUrl = entry.dataset.overlayImageUrl;
        
        if (!optionValue || !imageUrl) return;
        
        const optionLabel = document.createElement('label');
        optionLabel.className = 'post-selection__overlay-option';
        
        const optionInput = document.createElement('input');
        optionInput.type = 'checkbox';
        optionInput.name = `overlay-option-${variantId}`;
        optionInput.value = optionValue;
        optionInput.id = optionId;
        optionInput.dataset.variantId = variantId;
        optionInput.dataset.parentCheckbox = parentCheckboxId;
        optionInput.dataset.overlayUrl = imageUrl;
        optionInput.className = 'post-selection__overlay-option-input';
        
        // Select the first option by default
        if (index === 0) {
            optionInput.checked = true;
            optionLabel.classList.add('selected');
        }
        
        const optionText = document.createElement('span');
        optionText.className = 'post-selection__overlay-option-label';
        optionText.textContent = optionValue;
        
        optionInput.addEventListener('change', (e) => {
            if (checkbox.checked) {
                this._handleMultipleOverlayOptionsChange(variantId);
                
                // Update styles
                if (optionInput.checked) {
                    optionLabel.classList.add('selected');
                } else {
                    optionLabel.classList.remove('selected');
                }
            }
        });
        
        optionLabel.appendChild(optionInput);
        optionLabel.appendChild(optionText);
        optionLabel.setAttribute('for', optionId);
        optionsContainer.appendChild(optionLabel);
    });
    
    // Show the options container
    setTimeout(() => {
        const optionsElement = document.querySelector(
            `.post-selection__overlay-options[data-variant-id="${variantId}"]`
        );
        if (optionsElement) {
            optionsElement.classList.add('visible');
        }
    }, 100);
    
    // Activate the first option
    const firstOption = optionsContainer.querySelector('input[type="checkbox"]');
    if (firstOption) {
        firstOption.dispatchEvent(new Event('change'));
    }
  }

  _getOrCreateOptionsContainer(checkbox, variantId, productId) {
    // First check if the options container already exists
    let optionsContainer = document.querySelector(`.post-selection__overlay-options[data-variant-id="${variantId}"] .post-selection__option-buttons`);
    
    if (!optionsContainer) {
      // Get the checkbox's parent item
      const item = checkbox.closest('.post-selection__item');
      if (!item) return null;
      
      // Create container with proper class name
      const optionsWrapper = document.createElement('div');
      optionsWrapper.className = 'post-selection__overlay-options-wrapper';
      
      // Create the overlay options container
      const overlayOptions = document.createElement('div');
      overlayOptions.className = 'post-selection__overlay-options';
      overlayOptions.dataset.variantId = variantId;
      overlayOptions.dataset.productId = productId;
      
      const overlaySelector = document.createElement('div');
      overlaySelector.className = 'post-selection__overlay-selector';
      
      const optionButtons = document.createElement('div');
      optionButtons.className = 'post-selection__option-buttons';
      
      // Assemble the structure
      overlaySelector.appendChild(optionButtons);
      overlayOptions.appendChild(overlaySelector);
      optionsWrapper.appendChild(overlayOptions);
      
      // Insert directly after the item image for better association
      const itemLabel = item.querySelector('label');
      if (itemLabel) {
        const itemImage = itemLabel.querySelector('img');
        if (itemImage) {
          // Insert after the image element within the label
          itemImage.after(optionsWrapper);
        } else {
          // Fallback to inside the label
          itemLabel.appendChild(optionsWrapper);
        }
      } else {
        // Final fallback
        item.appendChild(optionsWrapper);
      }
      
      // Set the reference to the option buttons container
      optionsContainer = optionButtons;
      
      // console.log(`Created overlay options container for variant ${variantId} - always visible`);
    }
    
    return optionsContainer;
  }

  _clearOverlayOptions(variantId) {
    const optionsContainer = document.querySelector(`.post-selection__overlay-options[data-variant-id="${variantId}"]`);
    
    if (optionsContainer) {
      optionsContainer.remove();
    }
  }

  _handleOverlayOptionChange(optionInput) {
    const variantId = optionInput.dataset.variantId;
    const optionValue = optionInput.value;
    
    // Get or create state for this variant
    if (!this.overlayState.has(variantId)) {
        this.overlayState.set(variantId, {
            activeOption: null,
            baseOverlay: null
        });
    }
    
    const state = this.overlayState.get(variantId);
    
    // If there is already an active option, remove its overlay
    if (state.activeOption) {
        this._removeOverlayImage(`${variantId}-${state.activeOption}`);
    }
    
    // If there is a base overlay, remove it
    if (state.baseOverlay) {
        this._removeOverlayImage(variantId);
    }
    
    // Update state
    state.activeOption = optionValue;
    
    const parentCheckboxId = optionInput.dataset.parentCheckbox;
    const parentCheckbox = document.getElementById(parentCheckboxId);
    
    if (!parentCheckbox) return;
    
    const productId = parentCheckbox.dataset.productId;
    const title = `${parentCheckbox.dataset.title} - ${optionValue}`;
    
    // Add a new overlay for the selected option
    const directImageUrl = optionInput.dataset.overlayUrl;
    if (directImageUrl) {
        this._addOverlayImage(directImageUrl, title, `${variantId}-${optionValue}`);
    } else {
        const bikeProductId = this.product.id;
        const overlayDataElement = document.querySelector(
            `.post-selection__overlay-mapping[data-overlay-product-id="${productId}"][data-placement-product-id="${bikeProductId}"][data-overlay-option="${optionValue}"]`
        );
        
        if (overlayDataElement) {
            const overlayImageUrl = overlayDataElement.dataset.overlayImageUrl;
            if (overlayImageUrl) {
                this._addOverlayImage(overlayImageUrl, title, `${variantId}-${optionValue}`);
            }
        }
    }
  }

  _removeAllVariantOverlays(variantId) {
    const variantIdStr = String(variantId);
    
    // console.log(`Removing all overlays for variant ID: ${variantIdStr}`);
    
    // Find all overlays that start with this variant ID
    const relatedOverlays = [];
    
    this.activeOverlays.forEach(id => {
      if (id === variantIdStr || id.startsWith(`${variantIdStr}-`)) {
        relatedOverlays.push(id);
      }
    });
    
    // console.log(`Found ${relatedOverlays.length} overlays to remove: ${relatedOverlays.join(', ')}`);
    
    // Remove each related overlay
    relatedOverlays.forEach(id => {
      this._removeOverlayImage(id);
    });
    
    // Also remove any actual DOM elements that might have been missed
    const allOverlayElements = this.imageContainer.querySelectorAll('.post-selection__overlay-image');
    allOverlayElements.forEach(overlay => {
      const overlayId = overlay.getAttribute('data-variant-id');
      if (overlayId === variantIdStr || (overlayId && overlayId.startsWith(`${variantIdStr}-`))) {
        // console.log(`Removing overlay element: ${overlay.id}`);
        overlay.remove();
        this.activeOverlays.delete(overlayId);
      }
    });
  }

  _fetchAndAddOverlayImage(productId, variantId, title, event) {
    const clickedElement = event.target;
    console.log('Product ID:', productId);
    console.log('Variant ID:', variantId);
    console.log('Clicked element:', clickedElement);

    if (clickedElement && clickedElement.dataset.isGps === "true") {
        console.log(`Skipping overlay for GPS product ID: ${productId}`);
        return;
    }

    const bikeProductId = this.product.id;
    
    // First check if there are any positioning options
    const overlayDataElements = document.querySelectorAll(
        `.post-selection__overlay-mapping[data-overlay-product-id="${productId}"][data-placement-product-id="${bikeProductId}"]`
    );
    
    if (overlayDataElements.length > 0) {
        // If there is at least one positioning option, use the first one
        const firstOption = overlayDataElements[0];
        const overlayImageUrl = firstOption.dataset.overlayImageUrl;
        const optionValue = firstOption.dataset.overlayOption || 'Positie 1';
        
        if (overlayImageUrl) {
            // Add only with position
            this._addOverlayImage(overlayImageUrl, `${title} - ${optionValue}`, `${variantId}-${optionValue}`);
            return;
        }
    }
    
    // If there are no positioning options, use fallback
    const checkbox = document.querySelector(`.post-selection__item input[value="${variantId}"]`);
    const fallbackOverlay = checkbox?.dataset.overlayImg;
    
    if (fallbackOverlay) {
        // For fallback also add position, to keep consistency
        this._addOverlayImage(fallbackOverlay, `${title} - Positie 1`, `${variantId}-Positie 1`);
    }
  }

  _addOverlayImage(imageSrc, title, variantId) {
    if (!imageSrc) {
        console.log(`No overlay image found for ${title} (ID: ${variantId})`);
        return;
    }
    
    const variantIdStr = String(variantId);
    
    // Check if this overlay already exists
    if (this.activeOverlays.has(variantIdStr)) {
        console.log(`Overlay ID ${variantIdStr} already exists, skipping`);
        return;
    }
    
    console.log(`Adding overlay image for ${title} (ID: ${variantIdStr}): ${imageSrc}`);
    
    const overlayImage = document.createElement('img');
    overlayImage.src = imageSrc;
    overlayImage.classList.add('post-selection__overlay-image');
    overlayImage.classList.add('preloaded');
    overlayImage.id = `overlay-image-${variantIdStr}`;
    overlayImage.setAttribute('data-variant-id', variantIdStr);
    overlayImage.title = title || '';
    
    const parts = variantIdStr.split('-');
    const baseVariantId = parts[0];
    let staticZIndex = this.itemZIndexMap.get(baseVariantId) || 50;
    let finalZIndex = staticZIndex * 10;
    
    if (parts.length > 1) {
        const optionPart = parts.slice(1).join('-');
        if (optionPart.toLowerCase().includes('front')) {
            finalZIndex += 2;
        } else if (optionPart.toLowerCase().includes('rear')) {
            finalZIndex += 1;
        } else {
            // Extract the position number from the option value
            const optionIndex = parseInt(optionPart.match(/\d+/)?.[0] || '1');
            finalZIndex += optionIndex;
        }
    }
    
    overlayImage.style.zIndex = Math.floor(finalZIndex);
    this.imageContainer.appendChild(overlayImage);
    this.activeOverlays.add(variantIdStr);
    console.log(`Active overlays: ${Array.from(this.activeOverlays).join(', ')}`);
    
    setTimeout(() => {
        overlayImage.classList.remove('preloaded');
    }, 300);
  }
  
  _removeOverlayImage(variantId) {
    const overlay = document.getElementById(`overlay-image-${variantId}`);
    if (overlay) {
        overlay.remove();
        
        // Clear state if this is the base ID
        if (this.overlayState.has(variantId)) {
            this.overlayState.delete(variantId);
        }
        
        // Remove from active overlays
        this.activeOverlays.delete(variantId);
    }
  }

  _initializeAccessoryOverlays() {
    // First find ALL accessories, not just checked ones
    const allAccessories = document.querySelectorAll(
      ".post-selection__item input[type='checkbox']"
    );
    
    // Create overlay options for ALL accessories
    allAccessories.forEach(checkbox => {
      const productId = checkbox.dataset.productId;
      const variantId = checkbox.value;
      
      if (productId) {
        // Check if this product has overlay options and create the UI for them
        this._preloadOverlayOptions(productId, variantId, checkbox);
      }
    });
    
    // Now process checked accessories for actual overlay display
    const checkedAccessories = document.querySelectorAll(
      ".post-selection__item input[type='checkbox']:checked"
    );
    
    checkedAccessories.forEach(checkbox => {
      const productId = checkbox.dataset.productId;
      const variantId = checkbox.value;
      const title = checkbox.dataset.title;
      
      if (productId) {
        // Process overlay for checked items
        this._applyOverlaysForCheckedItem(productId, variantId, checkbox);
      }
    });
  }
  
  // New method to preload overlay options without applying them
  _preloadOverlayOptions(productId, variantId, checkbox) {
    const bikeProductId = this.product.id;
    
    // Find all overlay entries that match this product combination and have an overlay_option
    const overlayEntries = document.querySelectorAll(
      `.post-selection__overlay-mapping[data-overlay-product-id="${productId}"][data-placement-product-id="${bikeProductId}"][data-overlay-option]`
    );
    
    if (overlayEntries.length === 0) {
      // No overlay options for this accessory
      return;
    }
    
    // console.log(`Found ${overlayEntries.length} overlay options for product ${productId}`);
    
    // Completely disable the checkbox and replace with a non-interactive element
    const item = checkbox.closest('.post-selection__item');
    if (!item) return;
    
    // Get base price from the main checkbox - each option will use the FULL price
    const basePrice = Number(checkbox.dataset.price || 0);
    
    // Completely disable the original checkbox
    checkbox.disabled = true;
    checkbox.classList.add('post-selection__hidden-checkbox');
    
    // Add selection indicator to the item title
    const itemTitle = item.querySelector('.post-selection__item-product-title');
    
    // Create a visual indicator that shows the selection state at the checkbox position
    const checkboxLabel = checkbox.closest('label');
    if (checkboxLabel) {
      const selectionIndicator = document.createElement('div');
      selectionIndicator.className = 'post-selection__selection-indicator';
      selectionIndicator.dataset.forVariant = variantId;
      
      // Create checkmark that will appear when selected
      const checkmark = document.createElement('div');
      checkmark.className = 'post-selection__selection-checkmark';
      checkmark.innerHTML = '✓';
      
      // Set initial visibility based on checkbox state
      if (!checkbox.checked) {
        checkmark.classList.add('post-selection__hidden');
      }
      
      selectionIndicator.appendChild(checkmark);
      
      // Insert at the beginning of the label
      checkboxLabel.insertBefore(selectionIndicator, checkboxLabel.firstChild);
    }
    
    // Create the overlay options container even if the checkbox is not checked
    let optionsContainer = this._getOrCreateOptionsContainer(checkbox, variantId, productId);
    if (!optionsContainer) return;
    
    // Clear existing options
    optionsContainer.innerHTML = '';
    
    // Create a checkbox for each option (not radio button, to allow multiple selections)
    overlayEntries.forEach((entry, index) => {
      const optionValue = entry.dataset.overlayOption;
      const optionId = `overlay-option-${variantId}-${index}`;
      const parentCheckboxId = checkbox.id;
      const imageUrl = entry.dataset.overlayImageUrl;
      
      // Use the full price for each option instead of splitting it
      const optionPrice = Number(entry.dataset.overlayOptionPrice || basePrice);
      
      if (!optionValue || !imageUrl) return;
      
      // Create the checkbox and label
      const optionLabel = document.createElement('label');
      optionLabel.className = 'post-selection__overlay-option';
      
      const optionInput = document.createElement('input');
      optionInput.type = 'checkbox'; // Use checkbox not radio
      optionInput.name = `overlay-option-${variantId}-${index}`; // Different names for checkboxes
      optionInput.value = optionValue;
      optionInput.id = optionId;
      optionInput.dataset.variantId = variantId;
      optionInput.dataset.parentCheckbox = parentCheckboxId;
      optionInput.dataset.overlayUrl = imageUrl;
      optionInput.dataset.optionIndex = index;
      optionInput.dataset.optionPrice = optionPrice;
      optionInput.className = 'post-selection__overlay-option-input';
      
      // Default the first option to checked if parent is checked
      if (index === 0 && checkbox.checked) {
        optionInput.checked = true;
        optionLabel.classList.add('post-selection__option-selected');
      }
      
      const optionText = document.createElement('span');
      optionText.className = 'post-selection__overlay-option-label';
      optionText.textContent = optionValue;
      
      // Add event listener to the checkbox
      optionInput.addEventListener('change', (e) => {
        // When an option changes, we need to handle all the main item's behavior
        const parentCheckbox = document.getElementById(parentCheckboxId);
        
        // Update the selection indicator
        const selectionIndicator = document.querySelector(`.post-selection__selection-indicator[data-for-variant="${variantId}"]`);
        if (selectionIndicator) {
          const checkmark = selectionIndicator.querySelector('.post-selection__selection-checkmark');
          
          // Check if any options are selected
          const anyOptionSelected = document.querySelectorAll(
            `.post-selection__overlay-option-input[data-variant-id="${variantId}"]:checked`
          ).length > 0;
          
          // Update visual indicator
          if (checkmark) {
            if (anyOptionSelected) {
              checkmark.classList.remove('post-selection__hidden');
            } else {
              checkmark.classList.add('post-selection__hidden');
            }
          }
          
          if (anyOptionSelected) {
            selectionIndicator.classList.add('post-selection__indicator-selected');
          } else {
            selectionIndicator.classList.remove('post-selection__indicator-selected');
          }
        }
        
        // Programmatically handle the parent checkbox state
        if (parentCheckbox) {
          const anyOptionSelected = document.querySelectorAll(
            `.post-selection__overlay-option-input[data-variant-id="${variantId}"]:checked`
          ).length > 0;
          
          // Only change state if different from current
          if (parentCheckbox.checked !== anyOptionSelected) {
            parentCheckbox.checked = anyOptionSelected;
            // Trigger change event to update prices, overview, etc.
            const event = new Event('change', { bubbles: true });
            parentCheckbox.dispatchEvent(event);
          } else {
            // Even if the checkbox state hasn't changed, we still need to update prices
            // because the selected options changed
            this._updatePrices();
            this._updateOverview();
          }
        }
        
        // Update overlays based on the current selection
        this._handleMultipleOverlayOptionsChange(variantId);
        
        // Update the option label styling
        if (optionInput.checked) {
          optionLabel.classList.add('post-selection__option-selected');
        } else {
          optionLabel.classList.remove('post-selection__option-selected');
        }
      });
      
      // Assemble the option
      optionLabel.appendChild(optionInput);
      optionLabel.appendChild(optionText);
      optionLabel.setAttribute('for', optionId);
      optionsContainer.appendChild(optionLabel);
    });
  }
  
  // Method to apply overlays when checkbox is checked
  _applyOverlaysForCheckedItem(productId, variantId, checkbox) {
    const overlayOptions = document.querySelectorAll(
      `.post-selection__overlay-option-input[data-variant-id="${variantId}"]`
    );
    
    if (overlayOptions.length > 0) {
      // Select the first option by default if none are selected
      let anySelected = false;
      overlayOptions.forEach(option => {
        if (option.checked) anySelected = true;
      });
      
      if (!anySelected && overlayOptions.length > 0) {
        overlayOptions[0].checked = true;
      }
      
      // Apply overlays based on selected options
      this._handleMultipleOverlayOptionsChange(variantId);
    } else {
      // No options found, use standard overlay
      this._fetchAndAddOverlayImage(productId, variantId, checkbox.dataset.title, event);
    }
  }

  // Method to handle multiple options being selected
  _handleMultipleOverlayOptionsChange(variantId) {
    const selectedOptions = document.querySelectorAll(
        `.post-selection__overlay-option-input[data-variant-id="${variantId}"]:checked`
    );
    
    const parentCheckbox = document.querySelector(`.post-selection__item input[value="${variantId}"]`);
    if (!parentCheckbox || !parentCheckbox.checked) return;
    
    const productId = parentCheckbox.dataset.productId;
    if (!productId) return;
    
    // First remove all existing overlays for this variant
    this._removeAllVariantOverlays(variantId);
    
    // If there are no selected options, select the first one
    if (selectedOptions.length === 0) {
        const firstOption = document.querySelector(
            `.post-selection__overlay-option-input[data-variant-id="${variantId}"]`
        );
        if (firstOption) {
            firstOption.checked = true;
            const imageUrl = firstOption.dataset.overlayUrl;
            const optionValue = firstOption.value;
            const title = `${parentCheckbox.dataset.title} - ${optionValue}`;
            if (imageUrl) {
                this._addOverlayImage(imageUrl, title, `${variantId}-${optionValue}`);
            }
        }
        return;
    }
    
    // Add overlays for ALL selected options
    selectedOptions.forEach(option => {
        const optionValue = option.value;
        if (!optionValue) return;
        
        const optionId = `${variantId}-${optionValue}`;
        const imageUrl = option.dataset.overlayUrl;
        const title = `${parentCheckbox.dataset.title} - ${optionValue}`;
        
        if (imageUrl) {
            // Add each overlay with a unique ID
            this._addOverlayImage(imageUrl, title, optionId);
        }
    });
  }

  // New method to initialize z-index map based on item order in UI
  _initializeZIndexMap() {
    // Get all accessory items in the UI (this captures their natural order)
    const allAccessoryItems = document.querySelectorAll(".post-selection__item");
    
    // COMPLETELY INVERTED APPROACH:
    // Assign LOWER z-indices to items at TOP
    // Assign HIGHER z-indices to items at BOTTOM
    // This way, items lower in the list appear on top
    
    // Start with a LOW z-index and INCREASE for each item
    let zIndex = 10;
    
    // console.log(`Initializing z-index map for ${allAccessoryItems.length} accessories (INVERTED: bottom items on top)`);
    
    // Loop through items in natural order (top to bottom)
    allAccessoryItems.forEach((item, index) => {
        // Find the checkbox to get the variant ID
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.value) {
            const variantId = checkbox.value;
            
            // The variant ID is the key, and its position-based z-index is the value
            this.itemZIndexMap.set(variantId, zIndex);
            // console.log(`Set z-index ${zIndex} for item ${index+1}/${allAccessoryItems.length}: variant ${variantId} - ${checkbox.dataset.title || 'Unknown'}`);
            
            // INCREASE z-index for next item (items lower in the list get HIGHER z-index)
            zIndex += 10; // Using larger increments for clearer separation
        }
    });
    
    // Log all mapped values for debugging
    // console.log('Z-index map after initialization:');
    // this.itemZIndexMap.forEach((value, key) => {
    //     console.log(`Variant ${key}: z-index ${value}`);
    // });
  }

  /**
   * Preload all overlay images to reduce lag when they are clicked
   * This loads the images in the background so they're ready when needed
   */
  _preloadAllOverlayImages() {
    // console.log('Preloading all overlay images...');
    
    // Find all overlay mappings in the DOM
    const allOverlayMappings = document.querySelectorAll('.post-selection__overlay-mapping');
    const imagesToPreload = new Set();
    
    // Collect all unique image URLs
    allOverlayMappings.forEach(mapping => {
      const imageUrl = mapping.dataset.overlayImageUrl;
      if (imageUrl) {
        imagesToPreload.add(imageUrl);
      }
    });
    
    // Also check for overlay images in checkbox data attributes
    const accessoryCheckboxes = document.querySelectorAll(".post-selection__item input[type='checkbox']");
    accessoryCheckboxes.forEach(checkbox => {
      const overlayImg = checkbox.dataset.overlayImg;
      if (overlayImg) {
        imagesToPreload.add(overlayImg);
      }
    });
    
    // Create a hidden div to hold the preloaded images
    const preloadContainer = document.createElement('div');
    preloadContainer.style.position = 'absolute';
    preloadContainer.style.width = '0';
    preloadContainer.style.height = '0';
    preloadContainer.style.overflow = 'hidden';
    preloadContainer.style.visibility = 'hidden';
    document.body.appendChild(preloadContainer);
    
    // Add a style tag to make overlay images appear instantly on first load
    // After first load, transitions will work normally for smooth experience
    const styleTag = document.createElement('style');
    styleTag.textContent = `
      .post-selection__overlay-image.preloaded {
        transition: none !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(styleTag);
    
    // Preload each image
    // console.log(`Preloading ${imagesToPreload.size} overlay images`);
    imagesToPreload.forEach(imageUrl => {
      const img = new Image();
      img.src = imageUrl;
      preloadContainer.appendChild(img);
      
      // Cache the image URL
      const parts = imageUrl.split('/');
      const imageName = parts[parts.length - 1].split('?')[0];
      this.overlayImageCache[imageName] = imageUrl;
      
      // Log when image is loaded
      img.onload = () => {
        // console.log(`Preloaded image: ${imageName}`);
      };
    });
  }
}
